import { useSaveData } from '@entities/common/savedData/index.ts';
import { useCallback, useLayoutEffect } from 'react';
import { scrollFast } from '@shared/helpers/index.ts';

export type CachedListData = {
  scrollY: number;
  pageNumber?: number;
};

export const useSaveScroll = (hash: string) => {
  const {
    data: cacheData,
    doSetStorageData: setListScrollData,
    doRemoveStorageData: clearListScrollData,
  } = useSaveData<CachedListData>(hash);

  useLayoutEffect(() => {
    const scrollY = cacheData?.scrollY || 0;
    scrollY && scrollFast(scrollY);
    cacheData && clearListScrollData();
  }, []);

  const saveCurrentScrollPosition = useCallback(() => {
    setListScrollData({ scrollY: window.scrollY });
  }, [setListScrollData]);

  return {
    cacheData,
    setListScrollData,
    clearListScrollData,
    saveCurrentScrollPosition,
  };
};
